import React from 'react';
import AttachmentModel from '../../../models/AttachmentModel';
import ItemSearchResult from '../../../models/ItemSearchResult';
import FormatUtils from '../../../utils/FormatUtils';

export interface Props {
    attachment: AttachmentModel
    handleItemClicked: (attachment: AttachmentModel) => void
    handleItemPreviewClicked: (attachment: AttachmentModel) => void

}

const AttachmentCard: React.FC<Props> = ({ attachment, handleItemClicked, handleItemPreviewClicked }) => {

    var backgroundColor = 'darkgray'
    var borderColor = 'black'

    let createdDate: string;

    const formatUtils = new FormatUtils();
    createdDate = formatUtils.formatDate(attachment.createdOn);

    function ItemClicked() {
        handleItemClicked(attachment);
    }

    function ItemPreviewClicked() {
        handleItemPreviewClicked(attachment);
    }

    return (
        <a style={{ margin: 15 }}>
            <div style={{ width: 276, height: 390, overflow: 'hidden', border: '1px solid black', margin: 15 }}>
                <div className="card card-user">
                    <div style={{ backgroundColor: backgroundColor, color: 'white', padding: 5, overflow: 'hidden', minHeight: 137 }} onClick={ItemClicked}>
                        <div style={{ fontSize: 23, minHeight: 80 }}>{attachment.name}</div>
                        <div style={{ margin: 0, maxHeight: 18, overflow: 'hidden', fontSize: 13 }}>{attachment.attachmentType.name}</div>
                        <div style={{ backgroundColor: 'black', marginTop:5, padding:5 }}>
                            <div style={{ maxHeight: 25, overflow: 'hidden', fontSize: 13, width: 250 }}>{createdDate}</div>
                            <div style={{ maxHeight: 25, overflow: 'hidden', fontSize: 13, width: 250 }}>{attachment.createdByUser.name}</div>
                        </div>
                    </div>
                    <div className="content" style={{ padding: 0 }} onClick={ItemPreviewClicked}>
                        <div style={{ width: 273, height: 207, overflow: 'hidden', backgroundColor: 'white', textAlign: 'center' }}>
                            <img className='attachmentCardImage' src={attachment.thumbnailUrl} alt="..." />
                        </div>
                    </div>
                </div>
            </div>
        </a>
    );
}
export default AttachmentCard;
